module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_4_1-e32397823d03c2db856a1ab2eb546478.png";